(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highborn-eye-gel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('hb-eye-gel');
  const source = document.getElementById('hb-eye-gel-data');
  if (!root || !source || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(source.textContent);
  const $ = selector => root.querySelector(selector);
  const form = $('#hb-eye-gel-form');
  const variantSelect = $('#hb-variant');
  const quantity = $('#hb-quantity');
  const cadence = $('#hb-cadence');
  const radios = [...root.querySelectorAll('[name="purchase"]')];
  const price = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:data.currency}).format(value / 100);
  const say = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('__' + name.toUpperCase() + '__', String(value)), data.strings[key]);
  const variant = () => data.variants.find(item => String(item.id) === variantSelect.value);
  const subscription = () => radios.find(item => item.checked)?.value === 'subscription';
  function update() {
    const v = variant();
    if (!v) { $('#hb-add').disabled = true; return; }
    const isSub = subscription();
    const plan = v.plans.find(item => String(item.id) === cadence.value);
    const count = Math.max(1, Number(quantity.value) || 1);
    const total = count * (isSub && plan ? plan.price : v.price);
    const min = v.plans.length ? Math.min(...v.plans.map(item => item.price)) : v.price;
    $('#hb-subChoice').hidden = !v.plans.length;
    $('#hb-oncePrice').textContent = price(v.price);
    $('#hb-subPrice').textContent = price(plan?.price ?? min);
    const saving = v.price - (plan?.price ?? min);
    $('#hb-savingPercent').textContent = saving > 0 ? Math.round(saving / v.price * 100) + '%' : '';
    $('#hb-savingAmount').textContent = saving > 0 ? say('save', {saving:price(saving)}) : '';
    $('#hb-cadenceWrap').hidden = !isSub;
    cadence.disabled = !isSub;
    cadence.required = isSub;
    $('#hb-add').disabled = !v.available || (isSub && !plan);
    $('#hb-add').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('add', {price:price(total)});
    $('#hb-billing').textContent = isSub ? plan ? say('sub_billing', {quantity:count,unit:say(count===1?'set':'sets'),price:price(total),plan:plan.name}) : say('choose_frequency') : say('once_billing',{quantity:count,unit:say(count===1?'set':'sets'),price:price(total)});
    $('#hb-stickyPrice').textContent = v.title + ' · ' + (isSub && !plan ? say('choose_interval') : price(total) + ' · ' + (isSub ? plan.name : say('one_time')));
    $('#hb-stickyAdd').disabled = !v.available;
    $('#hb-stickyAdd').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('sticky_add');
  }
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function renderMotion(img, control, playing) {
    img.src = playing ? img.dataset.motion : img.dataset.still;
    control.setAttribute('aria-pressed', String(playing));
    control.textContent = playing ? control.dataset.pauseLabel : control.dataset.playLabel;
  }
  root.querySelectorAll('[data-motion-target]').forEach(control => {
    const img = $('#' + control.dataset.motionTarget);
    if (img.dataset.motion) renderMotion(img, control, !reducedMotion.matches);
    control.addEventListener('click', () => renderMotion(img, control, control.getAttribute('aria-pressed') !== 'true'));
  });
  function selectImage(button) {
    root.querySelectorAll('[data-img]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
    $('#hb-heroImage').style.setProperty('--hero-zoom',button.dataset.zoom || '1');
    const img = $('#hb-heroImage');
    const motionControl = $('#hb-heroMotion');
    motionControl.hidden = !button.dataset.motion;
    img.dataset.still = button.dataset.img;
    img.dataset.motion = button.dataset.motion || '';
    if (button.dataset.motion) renderMotion(img, motionControl, !reducedMotion.matches);
    else img.src = button.dataset.img;
    $('#hb-heroImage').alt = button.querySelector('img').alt;
  }
  function updateVariant() {
    const v = variant();
    const selected = cadence.value;
    while (cadence.options.length > 1) cadence.remove(1);
    [...v.plans].sort((a,b) => a.name.localeCompare(b.name, 'en', {numeric:true})).forEach(plan => cadence.add(new Option(plan.name, String(plan.id))));
    cadence.value = v.plans.some(plan => String(plan.id) === selected) ? selected : '';
    if (!v.plans.length) radios.find(item => item.value === 'once').checked = true;
    const pack = data.images[v.title] || data.images['30ml'];
    const packAlt = say('pack_alt', {size:v.title});
    $('#hb-packThumb').dataset.img = pack;
    $('#hb-packThumb img').src = pack;
    $('#hb-packThumb img').alt = packAlt;
    $('#hb-packThumb').setAttribute('aria-label', packAlt);
    $('#hb-packThumb').dataset.zoom = v.title === '10ml' ? '1.2' : '1';
    $('#hb-packThumb img').style.transform = 'scale(' + $('#hb-packThumb').dataset.zoom + ')';
    const alternate = data.alternateImages[v.title];
    $('#hb-alternateThumb').hidden = !alternate;
    if (alternate) {
      $('#hb-alternateThumb').dataset.img = alternate;
      $('#hb-alternateThumb img').src = alternate;
      $('#hb-alternateThumb img').alt = packAlt;
      $('#hb-alternateThumb').setAttribute('aria-label', packAlt);
      $('#hb-alternateThumb').dataset.zoom = v.title === '30ml' ? '1.2' : '1';
      $('#hb-alternateThumb img').style.transform = 'scale(' + $('#hb-alternateThumb').dataset.zoom + ')';
    }
    selectImage($('#hb-packThumb'));
    update();
  }
  root.querySelectorAll('[data-img]').forEach(el => el.addEventListener('click', () => selectImage(el)));
  radios.forEach(el => el.addEventListener('change', update));
  quantity.addEventListener('change', update);
  cadence.addEventListener('change', update);
  variantSelect.addEventListener('change', () => {
    updateVariant();
    const url = new URL(window.location.href);
    url.searchParams.set('variant',variantSelect.value);
    window.history.replaceState({},'',url);
  });
  form.addEventListener('submit', event => {
    update();
    if ($('#hb-add').disabled) { event.preventDefault(); cadence.focus(); }
  });
  $('#hb-stickyAdd').addEventListener('click', () => {
    update();
    if ($('#hb-add').disabled) {
      $('#hb-cadenceWrap').scrollIntoView({behavior:reducedMotion.matches ? 'auto' : 'smooth',block:'center'});
      cadence.focus({preventScroll:true});
      return;
    }
    $('#hb-add').click();
  });
  radios.find(item => item.value === 'once').checked = true;
  cadence.value = '';
  updateVariant();
  let stickyFrame = 0;
  const syncSticky = () => {
    stickyFrame = 0;
    $('#hb-sticky').hidden = $('#hb-add').getBoundingClientRect().bottom >= 0;
  };
  const scheduleSticky = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(syncSticky); };
  window.addEventListener('scroll', scheduleSticky, {passive:true});
  window.addEventListener('resize', scheduleSticky, {passive:true});
  if ('IntersectionObserver' in window) new IntersectionObserver(scheduleSticky).observe($('#hb-add'));
  syncSticky();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highborn-four-phase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('hb-four-phase');
  const source = document.getElementById('hb-pdp-data');
  if (!root || !source || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(source.textContent);
  const $ = selector => root.querySelector(selector);
  const form = $('#hb-four-phase-form');
  const variantSelect = $('#hb-variant');
  const quantity = $('#hb-quantity');
  const cadence = $('#hb-cadence');
  const radios = [...root.querySelectorAll('[name="purchase"]')];
  const price = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:data.currency}).format(value / 100);
  const say = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('__' + name.toUpperCase() + '__', String(value)), data.strings[key]);
  const variant = () => data.variants.find(item => String(item.id) === variantSelect.value);
  const subscription = () => radios.find(item => item.checked)?.value === 'subscription';
  function update() {
    const v = variant();
    if (!v) { $('#hb-add').disabled = true; return; }
    const isSub = subscription();
    const plan = v.plans.find(item => String(item.id) === cadence.value);
    const count = Math.max(1, Number(quantity.value) || 1);
    const total = count * (isSub && plan ? plan.price : v.price);
    const min = v.plans.length ? Math.min(...v.plans.map(item => item.price)) : v.price;
    $('#hb-subChoice').hidden = !v.plans.length;
    $('#hb-oncePrice').textContent = price(v.price);
    $('#hb-subPrice').textContent = price(plan?.price ?? min);
    const saving = v.price - (plan?.price ?? min);
    $('#hb-savingPercent').textContent = saving > 0 ? Math.round(saving / v.price * 100) + '%' : '';
    $('#hb-savingAmount').textContent = saving > 0 ? say('save', {saving:price(saving)}) : '';
    $('#hb-cadenceWrap').hidden = !isSub;
    cadence.disabled = !isSub;
    cadence.required = isSub;
    $('#hb-add').disabled = !v.available || (isSub && !plan);
    $('#hb-add').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('add', {price:price(total)});
    $('#hb-billing').textContent = isSub ? plan ? say('sub_billing', {quantity:count,unit:say(count===1?'set':'sets'),price:price(total),plan:plan.name}) : say('choose_frequency') : say('once_billing',{quantity:count,unit:say(count===1?'set':'sets'),price:price(total)});
    $('#hb-stickyPrice').textContent = v.title + ' · ' + (isSub && !plan ? say('choose_interval') : price(total) + ' · ' + (isSub ? plan.name : say('one_time')));
    $('#hb-stickyAdd').disabled = !v.available;
    $('#hb-stickyAdd').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('sticky_add');
  }
  function selectImage(button) {
    root.querySelectorAll('[data-img]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
    $('#hb-heroImage').src = button.dataset.img;
    $('#hb-heroImage').alt = button.querySelector('img').alt;
  }
  function updateVariant() {
    const v = variant();
    const selected = cadence.value;
    while (cadence.options.length > 1) cadence.remove(1);
    [...v.plans].sort((a,b) => a.name.localeCompare(b.name, 'en', {numeric:true})).forEach(plan => cadence.add(new Option(plan.name, String(plan.id))));
    cadence.value = v.plans.some(plan => String(plan.id) === selected) ? selected : '';
    if (!v.plans.length) radios.find(item => item.value === 'once').checked = true;
    const isBottle = /bottle/i.test(v.title);
    const pack = isBottle ? data.images.bottle : data.images.jar;
    const packAlt = say(isBottle ? 'pack_bottle' : 'pack_jar');
    const serum = isBottle ? data.images.serumBottle : data.images.serumJar;
    const serumAlt = say(isBottle ? 'serum_bottle' : 'serum_jar');
    $('#hb-packThumb').dataset.img = pack;
    $('#hb-packThumb img').src = pack;
    $('#hb-packThumb img').alt = packAlt;
    $('#hb-packThumb').setAttribute('aria-label', packAlt);
    $('#hb-styledThumb').hidden = isBottle;
    $('#hb-serumThumb').dataset.img = serum;
    $('#hb-serumThumb img').src = serum;
    $('#hb-serumThumb img').alt = serumAlt;
    $('#hb-serumThumb').setAttribute('aria-label', serumAlt);
    $('#hb-serumPortrait').src = serum;
    $('#hb-serumPortrait').alt = serumAlt;
    selectImage($('#hb-packThumb'));
    update();
  }
  root.querySelectorAll('[data-img]').forEach(el => el.addEventListener('click', () => selectImage(el)));
  radios.forEach(el => el.addEventListener('change', update));
  quantity.addEventListener('change', update);
  cadence.addEventListener('change', update);
  variantSelect.addEventListener('change', updateVariant);
  form.addEventListener('submit', event => {
    update();
    if ($('#hb-add').disabled) { event.preventDefault(); cadence.focus(); }
  });
  $('#hb-stickyAdd').addEventListener('click', () => {
    update();
    if ($('#hb-add').disabled) {
      $('#hb-cadenceWrap').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
      cadence.focus({preventScroll:true});
      return;
    }
    $('#hb-add').click();
  });
  radios.find(item => item.value === 'once').checked = true;
  cadence.value = '';
  updateVariant();
  let stickyFrame = 0;
  const syncSticky = () => {
    stickyFrame = 0;
    $('#hb-sticky').hidden = $('#hb-add').getBoundingClientRect().bottom >= 0;
  };
  const scheduleSticky = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(syncSticky); };
  window.addEventListener('scroll', scheduleSticky, {passive:true});
  window.addEventListener('resize', scheduleSticky, {passive:true});
  if ('IntersectionObserver' in window) new IntersectionObserver(scheduleSticky).observe($('#hb-add'));
  syncSticky();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highborn-moisturiser"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('hb-moisturiser');
  const source = document.getElementById('hb-moisturiser-data');
  if (!root || !source || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(source.textContent);
  const $ = selector => root.querySelector(selector);
  const form = $('#hb-moisturiser-form');
  const variantSelect = $('#hb-variant');
  const quantity = $('#hb-quantity');
  const cadence = $('#hb-cadence');
  const radios = [...root.querySelectorAll('[name="purchase"]')];
  const price = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:data.currency}).format(value / 100);
  const say = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('__' + name.toUpperCase() + '__', String(value)), data.strings[key]);
  const variant = () => data.variants.find(item => String(item.id) === variantSelect.value);
  const subscription = () => radios.find(item => item.checked)?.value === 'subscription';
  function update() {
    const v = variant();
    if (!v) { $('#hb-add').disabled = true; return; }
    const isSub = subscription();
    const plan = v.plans.find(item => String(item.id) === cadence.value);
    const count = Math.max(1, Number(quantity.value) || 1);
    const total = count * (isSub && plan ? plan.price : v.price);
    const min = v.plans.length ? Math.min(...v.plans.map(item => item.price)) : v.price;
    $('#hb-subChoice').hidden = !v.plans.length;
    $('#hb-oncePrice').textContent = price(v.price);
    $('#hb-subPrice').textContent = price(plan?.price ?? min);
    const saving = v.price - (plan?.price ?? min);
    $('#hb-savingPercent').textContent = saving > 0 ? Math.round(saving / v.price * 100) + '%' : '';
    $('#hb-savingAmount').textContent = saving > 0 ? say('save', {saving:price(saving)}) : '';
    $('#hb-cadenceWrap').hidden = !isSub;
    cadence.disabled = !isSub;
    cadence.required = isSub;
    $('#hb-add').disabled = !v.available || (isSub && !plan);
    $('#hb-add').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('add', {price:price(total)});
    $('#hb-billing').textContent = isSub ? plan ? say('sub_billing', {quantity:count,unit:say(count===1?'set':'sets'),price:price(total),plan:plan.name}) : say('choose_frequency') : say('once_billing',{quantity:count,unit:say(count===1?'set':'sets'),price:price(total)});
    $('#hb-stickyPrice').textContent = v.title + ' · ' + (isSub && !plan ? say('choose_interval') : price(total) + ' · ' + (isSub ? plan.name : say('one_time')));
    $('#hb-stickyAdd').disabled = !v.available;
    $('#hb-stickyAdd').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('sticky_add');
  }
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function selectImage(button) {
    root.querySelectorAll('[data-img]').forEach(el => el.setAttribute('aria-pressed',String(el===button)));
    $('#hb-heroImage').src = button.dataset.img;
    $('#hb-heroImage').srcset = [480,800,1000].map(w=>button.dataset.img.replace('width=1000','width='+w)+' '+w+'w').join(', ');
    $('#hb-heroImage').alt = button.querySelector('img').alt;
    $('#hb-heroImage').style.objectPosition = button.dataset.position || 'center';
  }
  function updateVariant() {
    const v = variant();
    const selected = cadence.value;
    while (cadence.options.length > 1) cadence.remove(1);
    [...v.plans].sort((a,b) => a.name.localeCompare(b.name, 'en', {numeric:true})).forEach(plan => cadence.add(new Option(plan.name, String(plan.id))));
    cadence.value = v.plans.some(plan => String(plan.id) === selected) ? selected : '';
    if (!v.plans.length) radios.find(item => item.value === 'once').checked = true;
    selectImage($('#hb-packThumb'));
    update();
  }
  root.querySelectorAll('[data-img]').forEach(el => el.addEventListener('click', () => selectImage(el)));
  radios.forEach(el => el.addEventListener('change', update));
  quantity.addEventListener('change', update);
  cadence.addEventListener('change', update);
  variantSelect.addEventListener('change', () => {
    updateVariant();
    const url = new URL(window.location.href);
    url.searchParams.set('variant',variantSelect.value);
    window.history.replaceState({},'',url);
  });
  form.addEventListener('submit', event => {
    update();
    if ($('#hb-add').disabled) { event.preventDefault(); cadence.focus(); }
  });
  $('#hb-stickyAdd').addEventListener('click', () => {
    update();
    if ($('#hb-add').disabled) {
      $('#hb-cadenceWrap').scrollIntoView({behavior:reducedMotion.matches ? 'auto' : 'smooth',block:'center'});
      cadence.focus({preventScroll:true});
      return;
    }
    $('#hb-add').click();
  });
  radios.find(item => item.value === 'once').checked = true;
  cadence.value = '';
  updateVariant();
  let stickyFrame = 0;
  const syncSticky = () => {
    stickyFrame = 0;
    $('#hb-sticky').hidden = $('#hb-add').getBoundingClientRect().bottom >= 0;
  };
  const scheduleSticky = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(syncSticky); };
  window.addEventListener('scroll', scheduleSticky, {passive:true});
  window.addEventListener('resize', scheduleSticky, {passive:true});
  if ('IntersectionObserver' in window) new IntersectionObserver(scheduleSticky).observe($('#hb-add'));
  syncSticky();
})();

(() => {
  const root = document.getElementById('hb-moisturiser');
  if (!root) return;
  const syncReviewTotal = () => {
    const source = root.querySelector('#stamped-main-widget .stamped-summary-text');
    const caption = root.querySelector('.stamped-main-badge .stamped-badge-caption');
    const stars = root.querySelector('.stamped-main-badge .stamped-badge-starrating');
    if (!source || !caption || !stars) return;
    const count = Number(source.dataset.count), rating = Number(source.dataset.rating);
    if (!Number.isFinite(count) || count < 1 || !Number.isFinite(rating) || rating < 1 || rating > 5) return;
    const text = count.toLocaleString('en-GB') + ' reviews';
    if (caption.textContent !== text) caption.textContent = text;
    if (caption.dataset.reviews !== String(count)) caption.dataset.reviews = String(count);
    if (caption.dataset.rating !== String(rating)) caption.dataset.rating = String(rating);
    const label = 'Rated ' + rating + ' out of 5 stars. ' + text;
    if (stars.getAttribute('aria-label') !== label) stars.setAttribute('aria-label', label);
  };
  new MutationObserver(syncReviewTotal).observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['data-count','data-rating']});
  syncReviewTotal();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highborn-night-elixir"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('hb-night-elixir');
  const source = document.getElementById('hb-night-elixir-data');
  if (!root || !source || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(source.textContent);
  const $ = selector => root.querySelector(selector);
  const form = $('#hb-night-elixir-form');
  const variantSelect = $('#hb-variant');
  const quantity = $('#hb-quantity');
  const cadence = $('#hb-cadence');
  const radios = [...root.querySelectorAll('[name="purchase"]')];
  const price = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:data.currency}).format(value / 100);
  const say = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('__' + name.toUpperCase() + '__', String(value)), data.strings[key]);
  const variant = () => data.variants.find(item => String(item.id) === variantSelect.value);
  const subscription = () => radios.find(item => item.checked)?.value === 'subscription';
  function update() {
    const v = variant();
    if (!v) { $('#hb-add').disabled = true; return; }
    const isSub = subscription();
    const plan = v.plans.find(item => String(item.id) === cadence.value);
    const count = Math.max(1, Number(quantity.value) || 1);
    const total = count * (isSub && plan ? plan.price : v.price);
    const min = v.plans.length ? Math.min(...v.plans.map(item => item.price)) : v.price;
    $('#hb-subChoice').hidden = !v.plans.length;
    $('#hb-oncePrice').textContent = price(v.price);
    $('#hb-subPrice').textContent = price(plan?.price ?? min);
    const saving = v.price - (plan?.price ?? min);
    $('#hb-savingPercent').textContent = saving > 0 ? Math.round(saving / v.price * 100) + '%' : '';
    $('#hb-savingAmount').textContent = saving > 0 ? say('save', {saving:price(saving)}) : '';
    $('#hb-cadenceWrap').hidden = !isSub;
    cadence.disabled = !isSub;
    cadence.required = isSub;
    $('#hb-add').disabled = !v.available || (isSub && !plan);
    $('#hb-add').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('add', {price:price(total)});
    $('#hb-billing').textContent = isSub ? plan ? say('sub_billing', {quantity:count,unit:say(count===1?'set':'sets'),price:price(total),plan:plan.name}) : say('choose_frequency') : say('once_billing',{quantity:count,unit:say(count===1?'set':'sets'),price:price(total)});
    $('#hb-stickyPrice').textContent = v.title + ' jar · ' + (isSub && !plan ? say('choose_interval') : price(total) + ' · ' + (isSub ? plan.name : say('one_time')));
    $('#hb-stickyAdd').disabled = !v.available;
    $('#hb-stickyAdd').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('sticky_add');
  }
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function selectImage(button) {
    root.querySelectorAll('[data-img]').forEach(el => el.setAttribute('aria-pressed',String(el===button)));
    $('#hb-heroImage').src = button.dataset.img;
    $('#hb-heroImage').srcset = [480,800,1000].map(w=>button.dataset.img.replace('width=1000','width='+w)+' '+w+'w').join(', ');
    $('#hb-heroImage').alt = button.querySelector('img').alt;
    $('#hb-heroImage').style.objectPosition = button.dataset.position || 'center';
    $('#hb-imageSize').hidden = !(variant().title === '10ml' && ['hb-1Thumb','hb-3Thumb'].includes(button.id));
  }
  function updateVariant() {
    const v = variant();
    const selected = cadence.value;
    while (cadence.options.length > 1) cadence.remove(1);
    [...v.plans].sort((a,b) => a.name.localeCompare(b.name, 'en', {numeric:true})).forEach(plan => cadence.add(new Option(plan.name, String(plan.id))));
    cadence.value = v.plans.some(plan => String(plan.id) === selected) ? selected : '';
    if (!v.plans.length) radios.find(item => item.value === 'once').checked = true;
    const pack = data.images[v.title];
    const thumb = $('#hb-packThumb');
    thumb.dataset.img = pack;
    thumb.querySelector('img').src = pack.replace('width=1000','width=200');
    thumb.querySelector('img').alt = say('pack_alt',{size:v.title});
    thumb.setAttribute('aria-label',thumb.querySelector('img').alt);
    selectImage(thumb);
    update();
  }
  root.querySelectorAll('[data-img]').forEach(el => el.addEventListener('click', () => selectImage(el)));
  radios.forEach(el => el.addEventListener('change', update));
  quantity.addEventListener('change', update);
  cadence.addEventListener('change', update);
  variantSelect.addEventListener('change', () => {
    updateVariant();
    const url = new URL(window.location.href);
    url.searchParams.set('variant',variantSelect.value);
    window.history.replaceState({},'',url);
  });
  form.addEventListener('submit', event => {
    update();
    if ($('#hb-add').disabled) { event.preventDefault(); cadence.focus(); }
  });
  $('#hb-stickyAdd').addEventListener('click', () => {
    update();
    if ($('#hb-add').disabled) {
      $('#hb-cadenceWrap').scrollIntoView({behavior:reducedMotion.matches ? 'auto' : 'smooth',block:'center'});
      cadence.focus({preventScroll:true});
      return;
    }
    $('#hb-add').click();
  });
  radios.find(item => item.value === 'once').checked = true;
  cadence.value = '';
  updateVariant();
  let stickyFrame = 0;
  const syncSticky = () => {
    stickyFrame = 0;
    $('#hb-sticky').hidden = $('#hb-add').getBoundingClientRect().bottom >= 0;
  };
  const scheduleSticky = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(syncSticky); };
  window.addEventListener('scroll', scheduleSticky, {passive:true});
  window.addEventListener('resize', scheduleSticky, {passive:true});
  if ('IntersectionObserver' in window) new IntersectionObserver(scheduleSticky).observe($('#hb-add'));
  syncSticky();
})();

(() => {
  const root = document.getElementById('hb-night-elixir');
  if (!root) return;
  const syncReviewTotal = () => {
    const source = root.querySelector('#stamped-main-widget .stamped-summary-text');
    const caption = root.querySelector('.stamped-main-badge .stamped-badge-caption');
    const stars = root.querySelector('.stamped-main-badge .stamped-badge-starrating');
    if (!source || !caption || !stars) return;
    const count = Number(source.dataset.count), rating = Number(source.dataset.rating);
    if (!Number.isFinite(count) || count < 1 || !Number.isFinite(rating) || rating < 1 || rating > 5) return;
    const text = count.toLocaleString('en-GB') + ' reviews';
    if (caption.textContent !== text) caption.textContent = text;
    if (caption.dataset.reviews !== String(count)) caption.dataset.reviews = String(count);
    if (caption.dataset.rating !== String(rating)) caption.dataset.rating = String(rating);
    const label = 'Rated ' + rating + ' out of 5 stars. ' + text;
    if (stars.getAttribute('aria-label') !== label) stars.setAttribute('aria-label', label);
  };
  new MutationObserver(syncReviewTotal).observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['data-count','data-rating']});
  syncReviewTotal();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highborn-revive-defy"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('hb-revive-defy');
  const source = document.getElementById('hb-revive-defy-data');
  if (!root || !source || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(source.textContent);
  const $ = selector => root.querySelector(selector);
  const form = $('#hb-revive-defy-form');
  const variantSelect = $('#hb-variant');
  const quantity = $('#hb-quantity');
  const cadence = $('#hb-cadence');
  const radios = [...root.querySelectorAll('[name="purchase"]')];
  const price = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:data.currency}).format(value / 100);
  const say = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('__' + name.toUpperCase() + '__', String(value)), data.strings[key]);
  const variant = () => data.variants.find(item => String(item.id) === variantSelect.value);
  const subscription = () => radios.find(item => item.checked)?.value === 'subscription';
  function update() {
    const v = variant();
    if (!v) { $('#hb-add').disabled = true; return; }
    const isSub = subscription();
    const plan = v.plans.find(item => String(item.id) === cadence.value);
    const count = Math.max(1, Number(quantity.value) || 1);
    const total = count * (isSub && plan ? plan.price : v.price);
    const min = v.plans.length ? Math.min(...v.plans.map(item => item.price)) : v.price;
    $('#hb-subChoice').hidden = !v.plans.length;
    $('#hb-oncePrice').textContent = price(v.price);
    $('#hb-subPrice').textContent = price(plan?.price ?? min);
    const saving = v.price - (plan?.price ?? min);
    $('#hb-savingPercent').textContent = saving > 0 ? Math.round(saving / v.price * 100) + '%' : '';
    $('#hb-savingAmount').textContent = saving > 0 ? say('save', {saving:price(saving)}) : '';
    $('#hb-cadenceWrap').hidden = !isSub;
    cadence.disabled = !isSub;
    cadence.required = isSub;
    $('#hb-add').disabled = !v.available || (isSub && !plan);
    $('#hb-add').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('add', {price:price(total)});
    $('#hb-billing').textContent = isSub ? plan ? say('sub_billing', {quantity:count,unit:say(count===1?'set':'sets'),price:price(total),plan:plan.name}) : say('choose_frequency') : say('once_billing',{quantity:count,unit:say(count===1?'set':'sets'),price:price(total)});
    $('#hb-stickyPrice').textContent = (isSub && !plan ? say('choose_interval') : price(total) + ' · ' + (isSub ? plan.name : say('one_time')));
    $('#hb-stickyAdd').disabled = !v.available;
    $('#hb-stickyAdd').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('sticky_add');
  }
  const imageWidth = (url, width) => { const sized = new URL(url); sized.searchParams.set('width', width); return sized.href; };
  function selectImage(button) {
    root.querySelectorAll('[data-img]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
    const img = $('#hb-heroImage');
    img.srcset = [400,600,800,1000].map(width => imageWidth(button.dataset.img, width) + ' ' + width + 'w').join(', ');
    img.src = button.dataset.img;
    img.alt = button.querySelector('img').alt;
  }
  function updateVariant() {
    const v = variant();
    const selected = cadence.value;
    while (cadence.options.length > 1) cadence.remove(1);
    [...v.plans].sort((a,b) => a.name.localeCompare(b.name, 'en', {numeric:true})).forEach(plan => cadence.add(new Option(plan.name, String(plan.id))));
    cadence.value = v.plans.some(plan => String(plan.id) === selected) ? selected : '';
    if (!v.plans.length) radios.find(item => item.value === 'once').checked = true;
    const pack = data.images[v.title] || data.images['Default Title'];
    const packAlt = say('pack_alt', {size:v.title});
    $('#hb-packThumb').dataset.img = pack;
    $('#hb-packThumb img').src = imageWidth(pack, 200);
    $('#hb-packThumb img').alt = packAlt;
    $('#hb-packThumb').setAttribute('aria-label', packAlt);
    $('#hb-packThumb').dataset.zoom = '1';
    $('#hb-packThumb img').style.transform = 'scale(' + $('#hb-packThumb').dataset.zoom + ')';
    const alternate = data.alternateImages[v.title];
    $('#hb-alternateThumb').hidden = !alternate;
    if (alternate) {
      $('#hb-alternateThumb').dataset.img = alternate;
      $('#hb-alternateThumb img').src = imageWidth(alternate, 200);
      $('#hb-alternateThumb').dataset.zoom = '1';
      $('#hb-alternateThumb img').style.transform = 'scale(' + $('#hb-alternateThumb').dataset.zoom + ')';
    }
    selectImage($('#hb-packThumb'));
    update();
  }
  root.querySelectorAll('[data-img]').forEach(el => el.addEventListener('click', () => selectImage(el)));
  radios.forEach(el => el.addEventListener('change', update));
  quantity.addEventListener('change', update);
  cadence.addEventListener('change', update);
  variantSelect.addEventListener('change', () => {
    updateVariant();
    const url = new URL(window.location.href);
    url.searchParams.set('variant',variantSelect.value);
    window.history.replaceState({},'',url);
  });
  form.addEventListener('submit', event => {
    update();
    if ($('#hb-add').disabled) { event.preventDefault(); cadence.focus(); }
  });
  $('#hb-stickyAdd').addEventListener('click', () => {
    update();
    if ($('#hb-add').disabled) {
      $('#hb-cadenceWrap').scrollIntoView({behavior:reducedMotion.matches ? 'auto' : 'smooth',block:'center'});
      cadence.focus({preventScroll:true});
      return;
    }
    $('#hb-add').click();
  });
  radios.find(item => item.value === 'once').checked = true;
  cadence.value = '';
  updateVariant();
  let stickyFrame = 0;
  const syncSticky = () => {
    stickyFrame = 0;
    $('#hb-sticky').hidden = $('#hb-add').getBoundingClientRect().bottom >= 0;
  };
  const scheduleSticky = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(syncSticky); };
  window.addEventListener('scroll', scheduleSticky, {passive:true});
  window.addEventListener('resize', scheduleSticky, {passive:true});
  if ('IntersectionObserver' in window) new IntersectionObserver(scheduleSticky).observe($('#hb-add'));
  syncSticky();
})();


(() => {
  const root = document.getElementById('hb-revive-defy');
  if (!root) return;
  const syncReviewTotal = () => {
    const source = root.querySelector('#stamped-main-widget .stamped-summary-text');
    const caption = root.querySelector('.stamped-main-badge .stamped-badge-caption');
    const stars = root.querySelector('.stamped-main-badge .stamped-badge-starrating');
    if (!source || !caption || !stars) return;
    const count = Number(source.dataset.count), rating = Number(source.dataset.rating);
    if (!Number.isFinite(count) || count < 1 || !Number.isFinite(rating) || rating < 1 || rating > 5) return;
    const text = count.toLocaleString('en-GB') + ' reviews';
    if (caption.textContent !== text) caption.textContent = text;
    if (caption.dataset.reviews !== String(count)) caption.dataset.reviews = String(count);
    if (caption.dataset.rating !== String(rating)) caption.dataset.rating = String(rating);
    const label = 'Rated ' + rating + ' out of 5 stars. ' + text;
    if (stars.getAttribute('aria-label') !== label) stars.setAttribute('aria-label', label);
  };
  new MutationObserver(syncReviewTotal).observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['data-count','data-rating']});
  syncReviewTotal();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highborn-serum-sticky"]) return;
  try {
    
(() => {
  const sticky = document.getElementById('hb-serum-sticky');
  const source = document.getElementById('hb-serum-sticky-data');
  if (!sticky || !source || sticky.dataset.ready) return;
  sticky.dataset.ready = 'true';
  const data = JSON.parse(source.textContent);
  const button = document.getElementById('hb-serum-sticky-add');
  const summary = document.getElementById('hb-serum-sticky-summary');
  const status = document.getElementById('hb-serum-sticky-status');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:data.currency}).format(cents/100);
  let frame = 0;
  let adding = false;
  let sawBusy = false;
  function readForm() {
    const form = document.querySelector('form[data-zp-add-to-cart-form][data-productid="2914171845"]');
    const native = form?.querySelector('[data-zp-add-to-cart]');
    const variant = data.variants.find(v => String(v.id) === form?.querySelector('[name="id"]')?.value);
    const planValue = form?.querySelector('[name="selling_plan"]')?.value;
    const plan = variant?.plans.find(p => String(p.id) === planValue);
    const quantity = Math.max(1,Number(form?.querySelector('[name="quantity"]')?.value)||1);
    return {form,native,variant,plan,planValue,quantity};
  }
  function sync() {
    frame = 0;
    const {form,native,variant,plan,planValue,quantity} = readForm();
    sticky.hidden = !native || !variant || native.getBoundingClientRect().bottom >= 0;
    if (!variant || !native) return;
    if (adding && native.disabled) sawBusy = true;
    if (adding && sawBusy && !native.disabled) {
      const message = form.querySelector('[data-zp-product-messages]')?.textContent || '';
      status.hidden = !message.includes('Product has been added to cart');
      adding = false;
    }
    summary.textContent = variant.title + (quantity > 1 ? ' × ' + quantity : '') + ' · ' + money(quantity * (plan?.price ?? variant.price)) + ' · ' + (plan?.name || data.once);
    button.disabled = native.disabled || !variant.available || !!(planValue && !plan);
    button.textContent = !variant.available ? data.soldOut : data.add;
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
  button.addEventListener('click', () => {
    sync();
    const {form,native} = readForm();
    if (!native || button.disabled) return;
    if (!form.checkValidity()) {
      form.scrollIntoView({behavior:'smooth',block:'center'});
      form.reportValidity();
      return;
    }
    status.hidden = true;
    adding = true;
    sawBusy = false;
    native.click();
    schedule();
  });
  document.addEventListener('change',schedule);
  document.addEventListener('input',schedule);
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  const content = document.getElementById('15461971');
  if (content) new MutationObserver(schedule).observe(content,{subtree:true,childList:true,attributes:true});
  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highborn-serum"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('hb-serum');
  const source = document.getElementById('hb-serum-data');
  if (!root || !source || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(source.textContent);
  const $ = selector => root.querySelector(selector);
  const form = $('#hb-serum-form');
  const variantSelect = $('#hb-variant');
  const quantity = $('#hb-quantity');
  const cadence = $('#hb-cadence');
  const radios = [...root.querySelectorAll('[name="purchase"]')];
  const price = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:data.currency}).format(value / 100);
  const say = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll('__' + name.toUpperCase() + '__', String(value)), data.strings[key]);
  const variant = () => data.variants.find(item => String(item.id) === variantSelect.value);
  const subscription = () => radios.find(item => item.checked)?.value === 'subscription';
  function update() {
    const v = variant();
    if (!v) { $('#hb-add').disabled = true; return; }
    const isSub = subscription();
    const plan = v.plans.find(item => String(item.id) === cadence.value);
    const count = Math.max(1, Number(quantity.value) || 1);
    const total = count * (isSub && plan ? plan.price : v.price);
    const min = v.plans.length ? Math.min(...v.plans.map(item => item.price)) : v.price;
    $('#hb-subChoice').hidden = !v.plans.length;
    $('#hb-oncePrice').textContent = price(v.price);
    $('#hb-subPrice').textContent = price(plan?.price ?? min);
    const saving = v.price - (plan?.price ?? min);
    $('#hb-savingPercent').textContent = saving > 0 ? Math.round(saving / v.price * 100) + '%' : '';
    $('#hb-savingAmount').textContent = saving > 0 ? say('save', {saving:price(saving)}) : '';
    $('#hb-cadenceWrap').hidden = !isSub;
    cadence.disabled = !isSub;
    cadence.required = isSub;
    $('#hb-add').disabled = !v.available || (isSub && !plan);
    $('#hb-add').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('add', {price:price(total)});
    $('#hb-billing').textContent = isSub ? plan ? say('sub_billing', {quantity:count,unit:say(count===1?'set':'sets'),price:price(total),plan:plan.name}) : say('choose_frequency') : say('once_billing',{quantity:count,unit:say(count===1?'set':'sets'),price:price(total)});
    $('#hb-stickyPrice').textContent = v.title + ' · ' + (isSub && !plan ? say('choose_interval') : price(total) + ' · ' + (isSub ? plan.name : say('one_time')));
    $('#hb-stickyAdd').disabled = !v.available;
    $('#hb-stickyAdd').textContent = !v.available ? say('sold_out') : isSub && !plan ? say('choose_interval') : say('sticky_add');
  }
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function selectImage(button) {
    root.querySelectorAll('[data-img]').forEach(el => el.setAttribute('aria-pressed',String(el===button)));
    $('#hb-heroImage').src = button.dataset.img;
    $('#hb-heroImage').srcset = [480,800,1000].map(w=>button.dataset.img.replace('width=1000','width='+w)+' '+w+'w').join(', ');
    $('#hb-heroImage').alt = button.querySelector('img').alt;
  }
  function updateVariant() {
    const v = variant();
    const selected = cadence.value;
    while (cadence.options.length > 1) cadence.remove(1);
    [...v.plans].sort((a,b) => a.name.localeCompare(b.name, 'en', {numeric:true})).forEach(plan => cadence.add(new Option(plan.name, String(plan.id))));
    cadence.value = v.plans.some(plan => String(plan.id) === selected) ? selected : '';
    if (!v.plans.length) radios.find(item => item.value === 'once').checked = true;
    const pack = data.images[v.title] || data.images['50ml Jar'];
    const packAlt = say('pack_alt', {size:v.title});
    $('#hb-packThumb').dataset.img = pack;
    $('#hb-packThumb img').src = pack.replace('width=1000','width=200');
    $('#hb-packThumb img').alt = packAlt;
    $('#hb-packThumb').setAttribute('aria-label',packAlt);
    const alternateTitle = v.title === '30ml Jar' ? '50ml Jar' : '30ml Jar';
    $('#hb-alternateThumb').dataset.img = data.images[alternateTitle];
    $('#hb-alternateThumb img').src = data.images[alternateTitle].replace('width=1000','width=200');
    $('#hb-alternateThumb img').alt = say('pack_alt',{size:alternateTitle});
    $('#hb-alternateThumb').setAttribute('aria-label',say('pack_alt',{size:alternateTitle}));
    $('#hb-pumpThumb').hidden = v.title === '30ml Bottle';
    selectImage($('#hb-packThumb'));
    update();
  }
  root.querySelectorAll('[data-img]').forEach(el => el.addEventListener('click', () => selectImage(el)));
  radios.forEach(el => el.addEventListener('change', update));
  quantity.addEventListener('change', update);
  cadence.addEventListener('change', update);
  variantSelect.addEventListener('change', () => {
    updateVariant();
    const url = new URL(window.location.href);
    url.searchParams.set('variant',variantSelect.value);
    window.history.replaceState({},'',url);
  });
  form.addEventListener('submit', event => {
    update();
    if ($('#hb-add').disabled) { event.preventDefault(); cadence.focus(); }
  });
  $('#hb-stickyAdd').addEventListener('click', () => {
    update();
    if ($('#hb-add').disabled) {
      $('#hb-cadenceWrap').scrollIntoView({behavior:reducedMotion.matches ? 'auto' : 'smooth',block:'center'});
      cadence.focus({preventScroll:true});
      return;
    }
    $('#hb-add').click();
  });
  radios.find(item => item.value === 'once').checked = true;
  cadence.value = '';
  updateVariant();
  let stickyFrame = 0;
  const syncSticky = () => {
    stickyFrame = 0;
    $('#hb-sticky').hidden = $('#hb-add').getBoundingClientRect().bottom >= 0;
  };
  const scheduleSticky = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(syncSticky); };
  window.addEventListener('scroll', scheduleSticky, {passive:true});
  window.addEventListener('resize', scheduleSticky, {passive:true});
  if ('IntersectionObserver' in window) new IntersectionObserver(scheduleSticky).observe($('#hb-add'));
  syncSticky();
})();

(() => {
  const root = document.getElementById('hb-serum');
  if (!root) return;
  const syncReviewTotal = () => {
    const source = root.querySelector('#stamped-main-widget .stamped-summary-text');
    const caption = root.querySelector('.stamped-main-badge .stamped-badge-caption');
    const stars = root.querySelector('.stamped-main-badge .stamped-badge-starrating');
    if (!source || !caption || !stars) return;
    const count = Number(source.dataset.count), rating = Number(source.dataset.rating);
    if (!Number.isFinite(count) || count < 1 || !Number.isFinite(rating) || rating < 1 || rating > 5) return;
    const text = count.toLocaleString('en-GB') + ' reviews';
    if (caption.textContent !== text) caption.textContent = text;
    if (caption.dataset.reviews !== String(count)) caption.dataset.reviews = String(count);
    if (caption.dataset.rating !== String(rating)) caption.dataset.rating = String(rating);
    const label = 'Rated ' + rating + ' out of 5 stars. ' + text;
    if (stars.getAttribute('aria-label') !== label) stars.setAttribute('aria-label', label);
  };
  new MutationObserver(syncReviewTotal).observe(root, {childList:true, subtree:true, attributes:true, attributeFilter:['data-count','data-rating']});
  syncReviewTotal();
})();


  } catch(e) { console.error(e); }
})();
})();
